import { Preferences, SetOptions } from "@capacitor/preferences";

class CapacitorStorage {
  /**
   * The value from storage associated with the given key.
   *
   * @since 1.0.0
   * @param {string} key
   * @returns {Promise<string | null>}
   */
  async getItem(key:string) {

    const response = await Preferences.get({key});

    if (response.value){
      return JSON.parse(response.value)
    }

    else {
      return null
    }
  }


  /**
   * Set the value in storage for a given key.
   *
   * @since 1.0.0
   * @param {string} key
   * @param {string} value
   * @returns {Promise<void>}
   */
  async setItem(key:string, value:any) {
    
    const valueToSet = JSON.stringify(value)
    
    const options:SetOptions = {
      key:key,
      value:valueToSet
    }
    await Preferences.set(options);
  }

  /**
   * Remove the value from storage for a given key, if any.
   *
   * @since 1.0.0
   * @param {string} key
   * @returns {Promise<void>}
   */
  async removeItem(key:string) {
    await Preferences.remove({key});
  }

  /**
   * Return the list of known keys in storage.
   *
   * @since 1.0.0
   * @returns {Promise<string[] | undefined>}
   */
  async getAllKeys() {
    const response = await Preferences.keys();

    return response?.keys;
  }

  /**
   * Clear keys and values from storage.
   *
   * @since 1.0.0
   * @returns {Promise<void>}
   */
  async clear() {
    await Preferences.clear();
  }
}

export default new CapacitorStorage();